"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeenMetaConfigSchema = exports.KeenAdditionalConfigSchema = exports.KeenMetaConfigSchemaObj = exports.KeenAdditionalConfigSchemaObj = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
exports.KeenAdditionalConfigSchemaObj = {
    projectName: yup_lib_1.default.string().required().label('Project Name')
};
exports.KeenMetaConfigSchemaObj = {
    projectId: yup_lib_1.default.string().required(),
    readKey: yup_lib_1.default.string().required(),
    writeKey: yup_lib_1.default.string().required()
};
exports.KeenAdditionalConfigSchema = yup_lib_1.default
    .object()
    .shape(exports.KeenAdditionalConfigSchemaObj);
exports.KeenMetaConfigSchema = yup_lib_1.default
    .object()
    .shape(exports.KeenMetaConfigSchemaObj);
